<script>
import Form from '../Form.vue';
import HandlesZorgmailAccount from '../../mixins/HandlesZorgmailAccount';
import HandlesInstitute from '../../mixins/HandlesInstitute';
import handlesErrorResponses from '../../mixins/HandlesErrorResponses';
import axios from 'axios';
import ModalManager from '../../services/modalManager';
import SelectZorgmailAccount from '../Modals/SelectZorgmailAccount.vue';
import HandlesJobs from '../../mixins/Overview/HandlesJobs';
import HandlesActions from '../../mixins/Overview/HandlesActions';

export default {
        extends: Form,

        mixins: [
            HandlesInstitute,
            HandlesZorgmailAccount,
            handlesErrorResponses,
            HandlesJobs,
            HandlesActions,
        ],

        props: {
            isNew: {
                type: Boolean,
                required: true,
            },

            instituteChosenByClient: {
                type: Boolean,
                required: true,
            },

            templatesUrl: {
                type: String,
                required: true,
            },

            initialTemplates: {
                type: Array,
                required: true,
            },

            recipients: {
                type: Array,
                required: true,
            },

            updateUrl: {
                type: String,
                default: null,
            },

            downloadUrl: {
                type: String,
                default: null,
            },

            printUrl: {
                type: String,
                default: null,
            },
        },

        computed: {
            template() {
                return this.templates.find(template => String(template.id) === String(this.formData.template_id));
            },

            templateType() {
                return this.template ? this.template.template_type : null;
            },

            recipientFromTemplate() {
                if (!this.template) {
                    return undefined;
                }

                if (!this.template.recipient_type) {
                    return undefined;
                }

                return this.recipients.find(recipient => recipient.recipient_role === this.template.recipient_type);
            },

            recipientOfCopyOptions() {
                const recipientRole = this.formData.cc_recipient_role;
                if (!recipientRole) {
                    return [];
                }

                return this.recipients.filter(recipient => recipient.recipient_role === recipientRole);
            },

            selectedRoleHasSingleRecipient() {
                return this.recipientOfCopyOptions.length === 1;
            },

            ccIsShown() {
                return !!this.formData.cc_recipient_role && !this.selectedRoleHasSingleRecipient;
            },
        },

        data() {
            return {
                fetchingTemplates: false,
                templates: [],
            };
        },

        methods: {
            async updateTemplates() {
                this.fetchingTemplates = true;
                try {
                    this.templates = (await axios.get(this.templatesUrl, {
                        params: {
                            institute_id: this.formData.institute_id,
                        },
                    })).data.data;

                    this.formData.template_id = '';
                } catch (error) {
                    this.formData.template_id = '';

                    await this.handleErrorResponse(error);
                } finally {
                    this.fetchingTemplates = false;
                }
            },

            async save() {
                this.formSubmitted = true;

                await axios.patch(this.updateUrl, this.formData);
            },

            async saveAndDownload() {
                await this.save();
                await this.awaitAndProcessJob((await axios.get(this.downloadUrl)).data);

                this.formSubmitted = false;
            },

            async saveAndPrint() {
                await this.save();
                await this.awaitAndProcessJob((await axios.get(this.printUrl)).data);

                this.formSubmitted = false;
            },

            async sendWithZorgmail() {
                if (this.zorgmailAccounts.length === 1) {
                    this.formData.send_using_zorgmail_account_id = this.zorgmailAccounts[0].value;
                } else {
                    const accountId = await ModalManager.openComponentInModal(SelectZorgmailAccount, {}, {}, 'small');

                    if (!accountId) {
                        return;
                    }

                    this.formData.send_using_zorgmail_account_id = accountId;
                }

                this.formData.zorgmail = 1;
                this.formSubmitted = true;
                this.$nextTick(() => {
                    this.$refs.form.submit();
                });
            },
        },

        mounted() {
            if (this.isNew && !this.instituteChosenByClient &&
                String(this.instituteId) !== String(this.formData.institute_id)
            ) {
                this.formData.institute_id = this.instituteId;
            }

            this.formData.send_using_zorgmail_account_id = this.zorgmailAccountId;
            this.templates = this.initialTemplates;
        },

        watch: {
            'formData.institute_id'() {
                this.instituteId = this.formData.institute_id;
                this.updateTemplates();
            },
            'formData.template_id': {
                handler(newValue, oldValue) {
                    if (String(newValue) === String(oldValue)) {
                        return;
                    }

                    if (this.recipientFromTemplate) {
                        this.formData.recipient_id = this.recipientFromTemplate.value;
                    }
                },
                immediate: true,
            },
            'formData.send_using_zorgmail_account_id'(value) {
                this.zorgmailAccountId = value;
            },
            'formData.cc_recipient_role'(value) {
                if (this.selectedRoleHasSingleRecipient) {
                    this.formData.recipient_of_copy_id = this.recipients.find(recipient => recipient.recipient_role === value).value;
                } else {
                    this.formData.recipient_of_copy_id = null;
                }
            },
            'formData.recipient_of_copy_select'(value) {
                this.formData.recipient_of_copy_id = value;
            },
        },
    };
</script>
